/**
 * aerobis cart complementary.
 * IMPACT <product-recommendations> does not populate in cart/drawer.
 * Persistent asset: fetch /recommendations/products.json and paint cards.
 * AJAX section replace does not execute inline scripts.
 */
(function () {
  if (window.aerobisCartComplementary) return;

  function injectBusyStyle() {
    if (document.getElementById("aerobis-acc-busy-style")) return;
    var css =
      ".aerobis-cart-complementary .horizontal-product__cta .button[aria-busy=\"true\"]{pointer-events:none}" +
      ".aerobis-cart-complementary .horizontal-product__cta .button[aria-busy=\"true\"]:not(:has(.button__loader)){color:transparent!important}" +
      ".aerobis-cart-complementary .horizontal-product__cta .button[aria-busy=\"true\"]:not(:has(.button__loader))::after{" +
      "content:\"\";position:absolute;top:50%;left:50%;width:.55rem;height:.55rem;" +
      "margin:-.275rem 0 0 -.275rem;border:2px solid rgb(var(--button-text-primary));" +
      "border-right-color:transparent;border-radius:50%;animation:aerobis-acc-spin .55s linear infinite}" +
      "@keyframes aerobis-acc-spin{to{transform:rotate(360deg)}}";
    var style = document.createElement("style");
    style.id = "aerobis-acc-busy-style";
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function money(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return "";
    var amount = (n / 100).toFixed(2);
    var fmt =
      (window.themeVariables &&
        themeVariables.settings &&
        themeVariables.settings.moneyFormat) ||
      "{{amount}} €";
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(n / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function idsFrom(el, attr) {
    return (el.getAttribute(attr) || "")
      .split("|")
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function imgUrl(p) {
    var img = p.featured_image;
    if (img && typeof img === "object") img = img.src || img.url || "";
    if (!img && p.images && p.images[0]) {
      img = typeof p.images[0] === "string" ? p.images[0] : p.images[0].src;
    }
    if (img && img.indexOf("//") === 0) img = "https:" + img;
    if (img && img.indexOf("width=") === -1) {
      img += (img.indexOf("?") >= 0 ? "&" : "?") + "width=160";
    }
    return img || "";
  }

  function firstVariant(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].available) return vs[i];
    }
    return vs[0] || null;
  }

  function hasSellingPlans(p) {
    var groups = p.selling_plan_groups;
    if (groups && groups.length) return true;
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].requires_selling_plan) return true;
      if (vs[i].selling_plan_allocations && vs[i].selling_plan_allocations.length) {
        return true;
      }
    }
    return false;
  }

  function canAjaxAdd(p) {
    return (p.variants || []).length === 1 && !hasSellingPlans(p);
  }

  function cardHtml(p, addLabel, scope) {
    var v = firstVariant(p);
    var img = imgUrl(p);
    var url = p.url || root() + "products/" + (p.handle || "");
    var available = p.available !== false && v && v.available !== false;
    var imgTag = img
      ? '<a href="' + esc(url) + '"><img class="horizontal-product__image rounded-xs" src="' +
        esc(img) + '" alt="" width="80" height="80" loading="lazy"></a>'
      : "";
    var add = "";
    if (available && v && canAjaxAdd(p)) {
      add =
        '<button type="button" is="custom-button" class="button button--sm" data-acc-add="' +
        esc(String(v.id)) +
        '">' +
        esc(addLabel) +
        "</button>";
    } else if (available && v) {
      var drawerId = "quick-buy-horizontal-" + scope + "-" + String(p.id);
      var handle = (p.handle || "") + "?variant=" + String(v.id);
      add =
        '<button type="button" is="custom-button" class="button button--sm" aria-controls="' +
        esc(drawerId) +
        '" aria-expanded="false">' +
        esc(addLabel) +
        "</button>" +
        '<quick-buy-drawer id="' +
        esc(drawerId) +
        '" header-bordered open-from="bottom" handle="' +
        esc(handle) +
        '" role="region" aria-live="polite" class="quick-buy-drawer drawer"></quick-buy-drawer>';
    }
    return (
      '<div class="horizontal-product snap-start" data-product-id="' +
      esc(String(p.id)) +
      '">' +
      imgTag +
      '<div class="horizontal-product__info"><div class="v-stack gap-0.5">' +
      '<a href="' +
      esc(url) +
      '" class="text-sm bold"><span class="reversed-link hover:show">' +
      esc(p.title || "") +
      "</span></a>" +
      '<span class="price text-sm">' +
      money(p.price) +
      "</span></div>" +
      '<div class="horizontal-product__cta">' +
      add +
      "</div></div></div>"
    );
  }

  function fetchComp(productId) {
    var url =
      root() +
      "recommendations/products.json?product_id=" +
      encodeURIComponent(productId) +
      "&limit=10&intent=complementary";
    return fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j && j.products) || []; })
      .catch(function () { return []; });
  }

  function paint(el, products) {
    var title = el.getAttribute("data-title") || "Complete your setup";
    var addLabel = el.getAttribute("data-add") || "+ Add";
    var layout = el.getAttribute("data-layout") || "page";
    if (!products.length) {
      el.hidden = true;
      el.innerHTML = "";
      return;
    }
    var cards = products.map(function (p) { return cardHtml(p, addLabel, layout); }).join("");
    var block =
      '<div class="product-info__complementary-products v-stack gap-3 sm:gap-4">' +
      '<p class="aerobis-cart-complementary__title">' +
      esc(title) +
      "</p>" +
      '<div class="horizontal-product-list">' +
      cards +
      "</div></div>";
    el.innerHTML = block;
    el.hidden = false;
  }

  function isCartPage() {
    if (
      window.themeVariables &&
      themeVariables.settings &&
      themeVariables.settings.pageType === "cart"
    ) {
      return true;
    }
    try {
      var path = (window.location.pathname || "").replace(/\/+$/, "") || "/";
      return /\/cart$/.test(path);
    } catch (e) {
      return false;
    }
  }

  function mainCartSection() {
    return document.querySelector(".shopify-section--main-cart");
  }

  function sectionIdFrom(el) {
    if (!el || !el.id) return "";
    return String(el.id).replace("shopify-section-", "");
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    if (busy) {
      btn.setAttribute("aria-busy", "true");
    } else {
      btn.removeAttribute("aria-busy");
      btn.disabled = false;
    }
  }

  function readJson(r) {
    return r.text().then(function (text) {
      var json = {};
      try {
        json = text ? JSON.parse(text) : {};
      } catch (e) {
        json = {};
      }
      if (!r.ok) {
        throw new Error((json && (json.description || json.message)) || "add failed");
      }
      return json;
    });
  }

  function collectSectionIds() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sections }
      })
    );
    var mainId = sectionIdFrom(mainCartSection());
    if (mainId && sections.indexOf(mainId) === -1) sections.push(mainId);
    return sections;
  }

  function fetchSectionHtml(sectionId, pagePath) {
    var url = root() + String(pagePath || "").replace(/^\//, "");
    url += (url.indexOf("?") >= 0 ? "&" : "?") + "section_id=" + encodeURIComponent(sectionId);
    return fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .catch(function () { return ""; });
  }

  function attachSections(cart, requestedIds, addSections) {
    cart.sections = cart.sections || {};
    if (addSections) {
      Object.keys(addSections).forEach(function (id) {
        if (addSections[id]) cart.sections[id] = addSections[id];
      });
    }
    var mainId = sectionIdFrom(mainCartSection());
    var missing = (requestedIds || []).filter(function (id) {
      return !cart.sections[id];
    });
    if (!missing.length) return Promise.resolve(cart);
    return Promise.all(
      missing.map(function (id) {
        var path = id === mainId ? "cart" : "";
        return fetchSectionHtml(id, path).then(function (html) {
          if (html) cart.sections[id] = html;
        });
      })
    ).then(function () { return cart; });
  }

  function replaceMainCart(html) {
    var current = mainCartSection();
    if (!current || !html) return;
    var parsed = new DOMParser().parseFromString(html, "text/html");
    var next =
      (current.id && parsed.getElementById(current.id)) ||
      parsed.querySelector(".shopify-section--main-cart") ||
      parsed.querySelector(".shopify-section");
    if (next) current.replaceWith(next);
    else current.innerHTML = html;
  }

  function publishCart(cart) {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cart
        }
      })
    );
    if (!isCartPage()) return;
    var id = sectionIdFrom(mainCartSection());
    var html = (cart.sections && id && cart.sections[id]) || "";
    if (html) replaceMainCart(html);
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    if (btn && btn.getAttribute("aria-busy") === "true") return;
    setBusy(btn, true);

    var sections = collectSectionIds();
    var payload = { id: Number(variantId), quantity: 1 };
    if (sections.length) {
      payload.sections = sections;
      if (isCartPage()) payload.sections_url = root() + "cart";
    }

    fetch(root() + "cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(payload)
    })
      .then(readJson)
      .then(function (added) {
        return fetch(root() + "cart.js", {
          credentials: "same-origin",
          headers: { Accept: "application/json" }
        }).then(function (r) {
          if (!r.ok) throw new Error("cart failed");
          return r.json();
        }).then(function (cart) {
          return attachSections(cart, sections, added && added.sections);
        });
      })
      .then(function (cart) {
        publishCart(cart);
      })
      .catch(function () {
        setBusy(btn, false);
      });
  }

  function refresh(el) {
    var paid = idsFrom(el, "data-paid-ids");
    var skip = {};
    idsFrom(el, "data-in-cart-ids").forEach(function (id) { skip[id] = true; });
    if (!paid.length) {
      paint(el, []);
      return;
    }
    var key = paid.join(",") + ">" + Object.keys(skip).join(",");
    if (el.getAttribute("data-acc-key") === key && !el.hidden && el.innerHTML) return;
    el.setAttribute("data-acc-key", key);
    Promise.all(paid.map(fetchComp)).then(function (lists) {
      var seen = {};
      var out = [];
      lists.forEach(function (list) {
        list.forEach(function (p) {
          var id = String(p.id);
          if (!id || seen[id] || skip[id]) return;
          seen[id] = true;
          out.push(p);
        });
      });
      paint(el, out);
    });
  }

  function scan() {
    document.querySelectorAll("[data-aerobis-cart-complementary]").forEach(refresh);
  }

  document.addEventListener("click", function (event) {
    var t = event.target;
    if (t && t.nodeType === 3) t = t.parentElement;
    var btn = t && t.closest && t.closest("[data-acc-add]");
    if (!btn) return;
    event.preventDefault();
    addToCart(btn.getAttribute("data-acc-add"), btn);
  });

  document.addEventListener("cart:change", function () { setTimeout(scan, 250); });
  document.addEventListener("cart:refresh", function () { setTimeout(scan, 250); });

  if (window.MutationObserver) {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          if (
            n.hasAttribute && n.hasAttribute("data-aerobis-cart-complementary") ||
            (n.querySelector && n.querySelector("[data-aerobis-cart-complementary]"))
          ) {
            scan();
            return;
          }
        }
      }
    });
    var startMo = function () {
      if (document.documentElement) {
        mo.observe(document.documentElement, { childList: true, subtree: true });
      }
    };
    if (document.documentElement) startMo();
    else document.addEventListener("DOMContentLoaded", startMo);
  }

  function boot() { injectBusyStyle(); scan(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.aerobisCartComplementary = { refresh: scan };
})();
